<i18n>
{
  "en": {
    "title": "Sustainable Industry Highlights 2017-2018",
    "description": "We’re leaders in making industry simpler and more sustainable with new levels of decision-making capabilities and efficiency. Learn about System Platform 2017, powered by Wonderware™, setting a new standard for industrial organization. Read about our green industry solutions and Waterforce’s sustainable success story.",
    "ourCustomers": {
      "section": "Our Customers",
      "title": "Industry",
      "industry": {
        "highlights": {
          "title": "Sustainable industry highlights",
          "para": "At Schneider Electric, digitization makes all the difference in our Industry Business, accounting for 22 percent of our business in 2017. We’re leaders in making industry simpler and more profitable. Last year was one of great progress with the introduction of EcoStruxure for Industry in April 2017. Our leading, open Industrial Internet of Things (IIoT) approach increases end-to-end operational efficiency with more dynamic control for better business results. We’re changing the sustainability game for industries worldwide by delivering new levels of intelligence, decision-making capabilities, productivity, and efficiency.",
          "paraB": "Featuring next-generation System Platform 2017, powered by Wonderware™, this release delivered a new standard for operational excellence for industrial organizations. System Platform 2017 sets the new standard for operational excellence, situational awareness, and actionable intelligence, and can be built on any hardware or software regardless of age or manufacturer.",
          "paraC": "Increasingly, industries are looking to connectivity, mobility, cloud, and analytics, as well as edge intelligence in mission-critical environments to increase operational efficiency for better business results. Through connected products, edge control, and innovative apps, analytics, and services, EcoStruxure continues to bring automation to industry and infrastructure from machine manufacturers to process operators, and leads manufacturing of the future."
        },
        "table1": {
          "statement": "System Platform 2017 has impacted 100,000+ sites worldwide, as well as an ecosystem of 4,000 system integrators and implementation partners, and 160,000 developers to date.",
          "title": "A sample of our industry solutions",
          "para": "Impacted 100,000+ sites worldwide, as well as an ecosystem of 4,000 system integrators and implementation partners and 160,000 developers",
          "row1": {
            "cell1": {
              "title": "Apps, Analytics & Services"
            },
            "cell3": {
              "title": "Manufacturing Execution System (MES)",
              "p1": "Benefit from sustainable manufacturing operations, delivering unprecedented gains in productivity and efficiency."
            }
          },
          "row2": {
            "cell1": {
              "title": "Edge Control"
            },
            "cell3": {
              "title": "Modicon M580 PLC controller",
              "p1": "Drive productivity and boost performance with the first PLC with built-in, cybersecure Ethernet capabilities."
            }
          },
          "row3": {
            "cell1": {
              "title": "Connected Products"
            },
            "cell3": {
              "title": "Altivar Process variable speed drive",
              "p1": "Reduce OpEx and drive energy savings with this services oriented drive designed for process and utilities installations."
            }
          }
        },
        "barometer": {
          "title": "2015 – 2017 Planet <span class='t-nowrap'>& Society</span> barometer achievement",
          "one": {
            "title": "Climate & Development (sustainability offers)",
            "stat": "168,400 tons",
            "para": "of CO<sub>2</sub> avoided through maintenance, retrofit, and end-of-life services"
          },
          "cta": "See the full results"
        },
        "quote": {
          "para": "By leveraging our relationship with Schneider Electric, we can focus on our core business — effective water management, knowing that the information management, analytics, and automation side is covered.",
          "author": "Ron McFetridge",
          "title": "Director of WaterForce",
          "company": "Blackhills Farm, New Zealand"
        },
        "vid": {
          "title": "IIoT EcoStruxure&trade; at WaterForce Ensures Efficiency and Sustainability",
          "description": "Farmers report increased efficiency and reduced costs"
        },
        "waterForce": {
          "title": "Sustainable agriculture success story: Waterforce",
          "subtitle": "WaterForce’s sustainability journey",
          "para": "WaterForce had a bold vision to change the game for efficient agricultural irrigation using state-of-the-art IoT technology to change the farming paradigm. Powered by the Microsoft<sup>®</sup> Azure platform and Schneider’s EcoStruxure Industry IoT architecture, SCADAfarm is an integrated automation and information management solution developed for WaterForce, an irrigation solutions builder and water management company in New Zealand. In the first season alone, farmers report more control and visibility into operations, with up to 50 percent in energy savings."
        },
        "table2": {
          "title": "WaterForce's sustainable solutions",
          "colHeaders": {
            "left": "What",
            "right": "Why"
          },
          "row1": {
            "cell1": {
              "title": "SCADAfarm, an integrated automation and information management platform"
            },
            "cell2": {
              "p1": "Delivers real-time visibility into system status and performance for better, faster decision-making, and more effective irrigation"
            }
          },
          "row2": {
            "cell1": {
              "title": "Scalability"
            },
            "cell2": {
              "p1": "Adaptable to meet ever-changing requirements — updates are handled seamlessly through the cloud"
            }
          },
          "row3": {
            "cell1": {
              "title": "Complete water management portal"
            },
            "cell2": {
              "p1": "Monitor and control irrigation systems over a wide geographical area and multiple properties, giving complete access to irrigation and wastewater systems from anywhere in the world"
            }
          },
          "row4": {
            "cell1": {
              "title": "Business opportunities"
            },
            "cell2": {
              "p1": "An expanded portfolio including remote monitoring, and troubleshooting and fault diagnosis helps WaterForce stay competitive"
            }
          }
        },
        "benefits": {
          "title": "Recorded benefits to date include:",
          "itemA": "Improved operational performance and crop yields",
          "itemB": "Saved time by allowing farmers to view equipment status on any device, instead of driving hours to check irrigation equipment",
          "itemC": "Enhanced safety procedures by pre-setting safe stop locations for pivots in case of high winds and providing the ability to stop equipment remotely should someone need to enter the irrigation field",
          "itemD": "Significant energy savings by shifting irrigation behavior and taking advantage of off-peak energy rates",
          "itemE": "Better management of water and wastewater across the farm, and easier compliance with regulatory requirements",
          "p1": "<strong>Get the facts on WaterForce's challenges, sustainable solutions, and results.</strong>",
          "ctaText": "Learn more"
        },
        "video2": {
          "title": "Innovation through Collaboration",
          "description": "Cyril Perducat, EVP IoT & Digital Offers"
        }
      }
    }
  },
  "fr": {
    "title": "Sustainable Industry Highlights 2017-2018",
    "description": "We’re leaders in making industry simpler and more sustainable with new levels of decision-making capabilities and efficiency. Learn about System Platform 2017, powered by Wonderware™, setting a new standard for industrial organization. Read about our green industry solutions and Waterforce’s sustainable success story.",
    "ourCustomers": {
      "section": "Nos Clients",
      "title": "Industries",
      "industry": {
        "highlights": {
          "title": "Faits marquants industries durables",
          "para": "Chez Schneider Electric, la numérisation fait toute la différence pour notre activité automatismes industriels, qui  représente 24 % de notre activité en 2017. Nous sommes leaders dans la simplification et la rentabilisation des processus industriels. L’année dernière a été marquée par un grand changement, avec l’introduction d’EcoStruxure™ pour l'industrie en avril 2017. Notre approche performante leader et ouverte reposant sur l’Internet des objets industriels améliore l’efficacité opérationnelle de bout en bout avec un contrôle plus dynamique pour de meilleurs résultats sur le plan économique. Nous changeons la donne en matière de durabilité pour les industries du monde entier en leur fournissant de nouveaux outils de veille, de prise de décision, de productivité et d’efficacité.",
          "paraB": "Cette version logicielle, équipée de la toute dernière génération de System Platform 2017, développée par Wonderware™, établit une nouvelle norme en matière d’excellence opérationnelle pour les organisations industrielles. Nouvelle référence dans le domaine de l’excellence opérationnelle, de la conscience situationnelle et de la veille exploitable, System Platform 2017 s’intègre à n’importe quel équipement matériel ou logiciel, quels que soient son ancienneté ou son fabricant.",
          "paraC": "Les industriels s'intéressent de plus en plus à la connectivité, à la mobilité, au cloud et aux outils d’analyse, ainsi qu'aux renseignements de terrain dans des environnements critiques afin d’accroître l’efficacité opérationnelle pour de meilleurs résultats. Grâce à ses produits connectés, à ses solutions de contrôle local, et à ses applications, outils d’analyse et services, EcoStruxure continue d’apporter des solutions d’automatismes aux industries et aux infrastructures, depuis les fabricants de machines jusqu’aux gestionnaires de processus. EcoStruxure se positionne à l'avant-garde de la production du futur."
        },
        "table1": {
          "statement": "System Platform 2017 a été déployé sur plus de 100 000 sites dans le monde grâce à la mobilisation d'un écosystème de 4 000 intégrateurs système et partenaires et de 160 000 développeurs.",
          "title": "Exemples de nos solutions pour l'industrie",
          "row1": {
            "cell1": {
              "title": "Applications, outils d'analyse et services"
            },
            "cell3": {
              "title": "Système MES (Manufacturing Execution System)",
              "p1": "Bénéficier d'opérations de fabrication durables/pérennes avec des gains inégalés en termes de productivité et d'efficacité."
            }
          },
          "row2": {
            "cell1": {
              "title": "Contrôle local (Edge control)"
            },
            "cell3": {
              "title": "Modicon M580 PLC (contrôleur logique programmable)",
              "p1": "Accroître la productivité et améliorer les performances grâce à ce premier PLC aux fonctions intégrées de cybersécurité et Ethernet."
            }
          },
          "row3": {
            "cell1": {
              "title": "Produits connectés"
            },
            "cell3": {
              "title": "Variateur de vitesse Altivar Process",
              "p1": "Réduire l'OPEX et maximiser les économies d'énergie grâce à ce variateur de vitesse orienté services et conçu pour des installations industrielles et d'infrastrutures."
            }
          }
        },
        "barometer": {
          "title": "Résultat du baromètre Planète & Société 2015 &mdash; 2017",
          "one": {
            "title": "Indicateur Climat et Développement (offres durables)",
            "stat": "168 400 tonnes",
            "para": "de CO<sub>2</sub> évitées grâce aux services de maintenance, récupération et fin de vie"
          },
          "cta": "Voir l’ensemble des résultats"
        },
        "quote": {
          "para": "Grâce à Schneider Electric, nous pouvons maintenant nous consacrer à  notre  cœur de métier, à savoir la gestion efficace de l'eau,  sachant que le management des informations, les outils d'analyse et toute la partie automatismes sont déjà pris en compte.",
          "author": "Ron McFetridge",
          "title": "Directeur de WaterForce",
          "company": "Blackhills Farm, New Zealand"
        },
        "vid": {
          "title": "Grâce à EcoStruxure<sup>TM</sup> Industry, WaterForce bénéficie de plus d'efficacité et de durabilité",
          "description": "Les agriculteurs constatent plus d'efficacité et la réductions des coûts"
        },
        "waterForce": {
          "title": "Un exemple de réussite durable dans le domaine de l'agriculture : WaterForce",
          "subtitle": "WaterForce et le développement durable",
          "para": "WaterForce se lance le pari audacieux de changer la donne et de bouleverser le paradigme agricole en rendant l’irrigation agricole plus efficace grâce à des technologies IdO de pointe. Propulsée par la plateforme Microsoft® Azure et l’architecture IdO EcoStruxure™ Industry de Schneider Electric, SCADAfarm est une plateforme intégrée de gestion de l'information et d’automatisation développée pour WaterForce, société néozélandaise de gestion de l’eau et conceptrice de solutions d’irrigation. Dès la première saison, les agriculteurs bénéficient d'un meilleur contrôle et d'une meilleure visibilité sur leur exploitation, et réalisent jusqu'à 50 % d'économies d'énergie."
        },
        "table2": {
          "title": "Les solutions durables pour WaterForce",
          "colHeaders": {
            "left": "Solution",
            "right": "Avantage"
          },
          "row1": {
            "cell1": {
              "title": "SCADAfarm, plateforme intégrée de gestion de l’information et d'automatismes"
            },
            "cell2": {
              "p1": "Offre une visibilité en temps réel sur l'état et les performances du système pour prendre de meilleures décisions, plus vite et pour une irrigation plus efficace"
            }
          },
          "row2": {
            "cell1": {
              "title": "Adaptabilité"
            },
            "cell2": {
              "p1": "Solution évolutive à l’infini pour s’adapter aux exigences en constante évolution ; les mises à jours sont gérées en toute transparence à travers le cloud"
            }
          },
          "row3": {
            "cell1": {
              "title": "Portail complet de gestion de l’eau"
            },
            "cell2": {
              "p1": "Une offre large comprenant la surveillance à distance,le  contrôle des systèmes d'irrigation et la détection des problèmes pour permettre à WaterForce de demeurer compétitif"
            }
          },
          "row4": {
            "cell1": {
              "title": "Nouveaux débouchés"
            },
            "cell2": {
              "p1": "Toute une gamme de services tels que la surveillance, le dépannage et le diagnostic à distance, pour aider WaterForce à rester compétitif"
            }
          }
        },
        "benefits": {
          "title": "Résultats obtenus :",
          "itemA": "Amélioration des performances opérationnelles et des rendements des récoltes",
          "itemB": "Gain de temps pour les agriculteurs qui peuvent consulter l'état de leurs équipements depuis n'importe quel appareil, plutôt que d'avoir à conduire des heures pour aller vérifier les équipements d'irrigation",
          "itemC": "Procédures de sécurité améliorées grâce à la pré-définition d'emplacements d'arrêt en toute sécurité pour les pivots en cas de vents forts et qui permettent d'arrêter les équipements à distance si quelqu'un doit pénétrer dans le champ en cours d'irrigation",
          "itemD": "Économies d'énergie significatives dues au changement des méthodes d'irrigation et aux tarifs énergétiques en heures creuses",
          "itemE": "Meilleure gestion de l'eau et des eaux usées dans l'exploitation agricole et respect plus facile des exigences réglementaires",
          "p1": "<strong>Pour en savoir plus sur les défis, les solutions durables et les résultats de WaterForce.</strong>",
          "ctaText": "En savoir plus"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('../../assets/img/our-customers/our-customers-industry-hero-lowres.jpg')" :hiResSrc="require('../../assets/img/our-customers/our-customers-industry-hero.jpg')" chapter="03" :section="$t('ourCustomers.section')" :title="$t('ourCustomers.title')"/>

    <section class="l-bg-white l-section-pad">
      <Txt>
        <h2 v-html="$t('ourCustomers.industry.highlights.title')"/>
        <p id="industry" v-html="$t('ourCustomers.industry.highlights.para')" />
        <p id="systemplatform2017" v-html="$t('ourCustomers.industry.highlights.paraB')" />
        <p v-html="$t('ourCustomers.industry.highlights.paraC')" />
      </Txt>
    </section>

    <section class="m-t-120 m-b-120">
      <Statement>
        <h3 v-html="$t('ourCustomers.industry.table1.statement')"></h3>
      </statement>
    </section>

    <section class="l-bg-white l-section-pad">
      <Table columns="3">
        <div slot="above">
          <h2 id="industrysolutions" v-html="$t('ourCustomers.industry.table1.title')"></h2>
        </div>
        <TableRow>
          <TableCell bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.industry.table1.row1.cell1.title')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/our-customers-Industry-row1.jpg')" class="no-overlay contain-img">
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.industry.table1.row1.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table1.row1.cell3.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 class="t-green-light" v-html="$t('ourCustomers.industry.table1.row2.cell1.title')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/our-customers-Industry-row2.jpg')" class="no-overlay contain-img">
          </TableCell>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.industry.table1.row2.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table1.row2.cell3.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.industry.table1.row3.cell1.title')"></h3>
          </TableCell>
          <TableCell :bgimg="require('@/assets/img/our-customers/PF151860A.jpg')" class="no-overlay contain-img">
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.industry.table1.row3.cell3.title')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table1.row3.cell3.p1')"></p>
          </TableCell>
        </TableRow>
      </Table>
    </section>

    <section class="m-b-120 m-t-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('ourCustomers.industry.barometer.title')"/>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('ourCustomers.industry.barometer.cta')" target="_blank"/>
        <BarometerIndicator class="col-xs-18" :color="$root.sassVars.cGreenLight" :title="$t('ourCustomers.industry.barometer.one.title')" :stat="$t('ourCustomers.industry.barometer.one.stat')" :body="$t('ourCustomers.industry.barometer.one.para')"/>
      </Barometer>
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <YouTubeVideo class="m-b-80" videoId="h4ePPiCIYCc" :title="$t('ourCustomers.industry.vid.title')" :description="$t('ourCustomers.industry.vid.description')" :preview="require('@/assets/img/thumbnails/Waterforce.jpg')"/>

      <TxtMedia>
        <h2 id="waterforcestory" class="m-b-45" slot="main-content" v-html="$t('ourCustomers.industry.waterForce.title')"/>
        <h3 class="m-b-15" slot="main-content" v-html="$t('ourCustomers.industry.waterForce.subtitle')"/>
        <p slot="main-content" v-html="$t('ourCustomers.industry.waterForce.para')" />
        <img slot="sidebar" src="@/assets/img/our-customers/our-customers-industry-img-full.jpg" />
        <!-- <iframe slot="sidebar" src="https://www.youtube.com/embed/h4ePPiCIYCc" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> -->
      </TxtMedia>
    </section>

    <section class="l-bg-white l-section-pad m-b-120">
      <Table class="m-b-50" columns="2">
        <div slot="above">
          <h2 id="waterforcesolutions" v-html="$t('ourCustomers.industry.table2.title')"/>
        </div>
        <TableRow>
          <TableCell>
            <h3 v-html="$t('ourCustomers.industry.table2.colHeaders.left')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table2.row1.cell1.title')"></p>
          </TableCell>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.industry.table2.colHeaders.right')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table2.row1.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.industry.table2.colHeaders.left')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table2.row2.cell1.title')"></p>
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.industry.table2.colHeaders.right')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table2.row2.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <h3 v-html="$t('ourCustomers.industry.table2.colHeaders.left')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table2.row3.cell1.title')"></p>
          </TableCell>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.industry.table2.colHeaders.right')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table2.row3.cell2.p1')"></p>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell class="t-white" bgc="#3dcd58">
            <h3 class="t-white" v-html="$t('ourCustomers.industry.table2.colHeaders.left')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table2.row4.cell1.title')"></p>
          </TableCell>
          <TableCell>
            <h3 v-html="$t('ourCustomers.industry.table2.colHeaders.right')"></h3>
            <p class="t-chartbody" v-html="$t('ourCustomers.industry.table2.row4.cell2.p1')"></p>
          </TableCell>
        </TableRow>
      </Table>

      <Txt class="m-b-50">
        <h3 v-html="$t('ourCustomers.industry.benefits.title')"/>
        <ul>
          <li v-html="$t('ourCustomers.industry.benefits.itemA')"/>
          <li v-html="$t('ourCustomers.industry.benefits.itemB')"/>
          <li v-html="$t('ourCustomers.industry.benefits.itemC')"/>
          <li v-html="$t('ourCustomers.industry.benefits.itemD')"/>
          <li v-html="$t('ourCustomers.industry.benefits.itemE')"/>
        </ul>
      </Txt>

      <Quote class="m-b-50" :photo="require('@/assets/img/our-customers/Ron-McFetridge_Waterforce_CS.jpg')" :name="$t('ourCustomers.industry.quote.author')" :title="$t('ourCustomers.industry.quote.title')">
        <div v-html="$t('ourCustomers.industry.quote.para')"></div>
      </Quote>

      <Txt>
        <p v-html="$t('ourCustomers.industry.benefits.p1')" class="t-grey"></p>
        <CTA target="_blank" :buttonText="$t('ourCustomers.industry.benefits.ctaText')" href="https://www.schneider-electric.com/en/work/campaign/life-is-on/case-study/waterforce.jsp"></CTA>
      </Txt>
    </section>

    <div class="l-content">
      <FooterNav
        nextRoute="OurCustomers_Infrastructure"
        prevRoute="OurCustomers_DataCenter" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import TxtMedia from '@/components/TxtMedia'
import ImageFull from '@/components/ImageFull'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'
import YouTubeVideo from '@/components/YouTubeVideo'

export default {
  name: 'OurCustomers_Industry',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    TxtMedia,
    Barometer,
    BarometerIndicator,
    ImageFull,
    Table,
    TableRow,
    TableCell,
    YouTubeVideo
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/our-customers/industry.vue